export default __webpack_public_path__ + "static/media/gallery20.553137f6.jpg";